const keyToken = "BRASIL_CONVENIOS_WEB_TOKEN";
const keyTypeUser = "BRASIL_CONVENIOS_WEB_TYPE_USER";
const ignoreUrl = ["/", "/recuperacao-senha", "/nova-senha"];

export { keyToken, keyTypeUser, ignoreUrl };
